import React, { useEffect, useMemo, useRef, useState } from "react";
import Avatar from "react-avatar";

const DropdownSelect = ({
  options,
  value,
  onChange,
  placeholder,
  disabled = false,
  className = "",
  showAvatars = false,
}) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  const selectedOption = useMemo(
    () => options.find((option) => option.value === value),
    [options, value]
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (disabled && open) {
      setOpen(false);
    }
  }, [disabled, open]);

  const handleSelect = (nextValue) => {
    onChange(nextValue);
    setOpen(false);
  };

  return (
    <div ref={containerRef} className={`fb-select ${className} ${disabled ? "is-disabled" : ""}`}>
      <button
        type="button"
        className="fb-select__trigger custom-select"
        onClick={() => !disabled && setOpen((prev) => !prev)}
        disabled={disabled}
      >
        <span className="fb-select__trigger-label">
          {showAvatars && selectedOption ? (
            <>
              <Avatar
                round={true}
                size="24"
                name={selectedOption.label || "Friend"}
                src={selectedOption.avatarSrc || ""}
              />
              <span>{selectedOption.label}</span>
            </>
          ) : (
            <span>{selectedOption?.label || placeholder}</span>
          )}
        </span>
        <span className="fb-select__chevron">▾</span>
      </button>

      {open && !disabled && (
        <ul className="fb-select__menu" role="listbox">
          {options.map((option) => (
            <li key={option.value}>
              <button
                type="button"
                className={`fb-select__option ${option.value === value ? "is-selected" : ""}`}
                onClick={() => handleSelect(option.value)}
              >
                {showAvatars ? (
                  <span className="fb-select__option-content">
                    <Avatar
                      round={true}
                      size="24"
                      name={option.label || "Friend"}
                      src={option.avatarSrc || ""}
                    />
                    <span>{option.label}</span>
                  </span>
                ) : (
                  option.label
                )}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default DropdownSelect;
